import script from "./UiButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiButton.vue?vue&type=script&lang=ts&setup=true"

import "./UiButton.vue?vue&type=style&index=0&id=78e32abe&lang=scss&scoped=true"
script.__scopeId = "data-v-78e32abe"

export default script